import React, { useContext } from 'react';
import { Flex } from '@jutro/layout';
import PropTypes from 'prop-types';
import cx from 'classnames';
import styles from './WMICModalHeader.module.scss';
import { TranslatorContext } from '@jutro/legacy/locale';

const WMICModalHeader = props => {
    const translator = useContext(TranslatorContext);

    const {
        title,
        headerLayout = { direction: 'row', justifyContent: 'left', alignItems: 'middle' },
        className,
    } = props;
    return (
        <Flex className={cx(styles.modalHeader, className)} {...headerLayout}>
            <h1>{translator(title)}</h1>
        </Flex>
    );
};

WMICModalHeader.propTypes = {
    title: PropTypes.shape({}).isRequired,
    headerLayout: PropTypes.shape({}),
};

export default WMICModalHeader;
